/* Timbrica — /sun-moon-tracker (sun & moon: sunrise/sunset, golden hour,
 * white nights, moon phase). 100% offline astronomy (SunCalc, BSD-2) — no API,
 * works behind any block and as a PWA. The map shows live sun & moon azimuth
 * lines from a pin and a time-scrubber sweeps the day.
 */
(function () {
  'use strict';
  var C = window.SUNMOON_CFG || {};
  var T = C.t || {};
  var tr = function (k) { return T[k] != null ? T[k] : k; };
  var $ = function (id) { return document.getElementById(id); };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };

  // ── Sun + moon: the shared astro core (public/js/astro-core.js) ────────────
  // This block used to be a private copy of SunCalc. /compass needs the same
  // maths (the sun's azimuth is the only heading reference that works without
  // a magnetometer), so it moved into one shared, unit-tested module rather
  // than becoming a third copy. `tests/astro-core.test.mjs` holds a frozen copy of
  // the pre-move code and asserts 10 176 identical samples across eight places
  // and a full year, so the move provably changed nothing here.
  var PI = Math.PI, rad = PI / 180, dayMs = 864e5;
  var AC = window.AstroCore;
  var sunPos = AC.sunPos, moonPos = AC.moonPos, getTimes = AC.sunTimes,
      moonTimes = AC.moonTimes, moonIllum = AC.moonIllum;

  // ── helpers ────────────────────────────────────────────────────────────────
  // Times are shown in the LOCATION's local time: exact browser tz when the
  // point came from geolocation (the user's own place, DST included), else the
  // longitude-derived standard time so a far pin reads the same for any viewer.
  function hhmm(dt) {
    if (!dt || isNaN(dt)) return '—';
    var d2 = new Date(dt.valueOf() + locOffsetMin() * 60000);
    try { return d2.toLocaleTimeString(C.locale, { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' }); } catch (x) { return d2.toISOString().slice(11, 16); }
  }
  function dur(ms) { if (ms == null || ms < 0 || isNaN(ms)) return '—'; var m = Math.round(ms / 60000); return Math.floor(m / 60) + tr('h_short') + ' ' + (m % 60) + tr('m_short'); }
  function phaseName(p) { var i = Math.round(p * 8) % 8; return tr('phase').split('|')[i]; }
  function phaseEmoji(p) { return ['🌑', '🌒', '🌓', '🌔', '🌕', '🌖', '🌗', '🌘'][Math.round(p * 8) % 8]; }
  function dest(lat, lon, brngRad, km) {
    var R = 6371, dR = km / R, lat1 = lat * rad, lon1 = lon * rad;
    var lat2 = Math.asin(Math.sin(lat1) * Math.cos(dR) + Math.cos(lat1) * Math.sin(dR) * Math.cos(brngRad));
    var lon2 = lon1 + Math.atan2(Math.sin(brngRad) * Math.sin(dR) * Math.cos(lat1), Math.cos(dR) - Math.sin(lat1) * Math.sin(lat2));
    return [lat2 / rad, lon2 / rad];
  }

  // ── state + map ────────────────────────────────────────────────────────────
  var map = null, pin = null, sunLine = null, moonLine = null, loc = null, baseDate = new Date(), scrubMin = null, fromGeo = false;
  function locOffsetMin() { return fromGeo ? -new Date().getTimezoneOffset() : (loc ? Math.round(loc[1] / 15) * 60 : 0); }
  function previewDate() {
    if (scrubMin == null) return new Date();
    var off = locOffsetMin() * 60000, nowL = Date.now() + off, midL = nowL - (nowL % dayMs);
    return new Date(midL - off + scrubMin * 60000);
  }

  function initMap() {
    if (!window.L || !$('smMap')) return;
    var tile = C.tile || {};
    map = L.map('smMap', { center: [C.home.lat, C.home.lon], zoom: C.home.z, minZoom: 2, maxZoom: 12, worldCopyJump: true });
    // Подложка через общий примитив: второй адрес (наш прокси <-> прямой CDN)
    // и честная строка, если не ответил ни один. Здесь стоял пустой
    // .on('tileerror', function () {}) — крючок был, внутри ничего, и
    // упавший хост давал ЧЁРНЫЙ прямоугольник без слова объяснения.
    if (window.__mapTiles) {
      window.__mapTiles.base(L, map, null, {
        slug: 'sun-moon-tracker', credit: tr('map_attr'), opts: { maxZoom: 19 }, text: tile.offline,
        styles: tile.styles, labels: tile.labels,
        onStyle: function (mode) {
          skin = RAMP[mode] || RAMP.dark;
          var st = document.querySelector('.sm-stage');
          if (st) st.setAttribute('data-basemap', mode);
          if (typeof drawLines === 'function' && loc) drawLines();
        }
      });
    } else if (window.__basemapFallback) {
      window.__basemapFallback(L, map, tr('map_attr'));
    }
    setLoc(C.home.lat, C.home.lon, false);
    map.on('click', function (ev) { setLoc(ev.latlng.lat, ev.latlng.lng, true); });
  }
  // Подпись точки — общий модуль GeoCity (public/js/geo-city.js): город на
  // языке страницы, румб и расстояние («↗ Город · 42 км»).
  function geoFill(lat, lon, elId, ok) {
    if (!window.GeoCity) return;
    GeoCity.fill(elId, lat, lon, { empty: '', ok: ok });
  }

  function setLoc(lat, lon, recenter, geo) {
    loc = [lat, lon]; fromGeo = !!geo;
    geoFill(lat, lon, 'smPlace', function () { return loc && loc[0] === lat && loc[1] === lon; });
    if (map && window.L) {
      if (!pin) pin = L.marker([lat, lon], { draggable: true }).addTo(map).on('dragend', function () { var p = pin.getLatLng(); setLoc(p.lat, p.lng, false); });
      else pin.setLatLng([lat, lon]);
      if (recenter) map.panTo([lat, lon]);
    }
    render();
  }
  /* На светлой подложке линия ещё и ТОЛЩЕ. Это не украшение: у тонкой линии
     доля краевых (сглаженных) пикселей велика, и на светлом фоне они падают
     почти до фона — замер 23.08 показал 36% «потерянных» пикселей против 14
     на тёмном. Один лишний пиксель ширины переводит линию из «видно, если
     искать» в «видно сразу». */
  var RAMP = {
    dark:  { sun: '#ffd24d', moon: '#cfe0ff', sunW: 3, moonW: 2 },
    light: { sun: '#8a5f00', moon: '#2c4d94', sunW: 4, moonW: 3 }
  };
  var skin = RAMP.dark;
  function drawLines() {
    if (!map || !loc) return;
    var d = previewDate(), s = sunPos(d, loc[0], loc[1]), m = moonPos(d, loc[0], loc[1]);
    var len = 900;
    if (sunLine) map.removeLayer(sunLine); if (moonLine) map.removeLayer(moonLine);
    /* Две палитры направлений. Жёлтый #ffd24d и бледно-синий #cfe0ff сделаны
       под чёрную карту; на positron (#fafaf8) обе линии выцветают, а именно
       они и есть ответ тула — «куда сейчас солнце». Цвета обязаны совпадать
       с кружками в чипах (см. --sm-sun/--sm-moon в блейде). */
    var sunCol = skin.sun, moonCol = skin.moon;
    if (s.altitude > -0.1) sunLine = L.polyline([loc, dest(loc[0], loc[1], s.azimuth + PI, len)], { color: sunCol, weight: skin.sunW, opacity: 0.85 }).addTo(map);
    else sunLine = null;
    if (m.altitude > -0.1) moonLine = L.polyline([loc, dest(loc[0], loc[1], m.azimuth + PI, len)], { color: moonCol, weight: skin.moonW, opacity: 0.75, dashArray: '6 5' }).addTo(map);
    else moonLine = null;
    $('smSunNow').textContent = tr('azimuth') + ' ' + Math.round((s.azimuth / rad + 180) % 360) + '° · ' + tr('altitude') + ' ' + Math.round(s.altitude / rad) + '°';
    $('smMoonNow').textContent = tr('azimuth') + ' ' + Math.round((m.azimuth / rad + 180) % 360) + '° · ' + tr('altitude') + ' ' + Math.round(m.altitude / rad) + '°';
  }

  function render() {
    if (!loc) return;
    var lat = loc[0], lon = loc[1], date = baseDate;
    var t = getTimes(date, lat, lon), mt = moonTimes(date, lat, lon), il = moonIllum(date), noonAlt = sunPos(t.solarNoon || date, lat, lon).altitude / rad, nadirAlt = sunPos(t.nadir || date, lat, lon).altitude / rad;

    // sun card
    set('smSunrise', hhmm(t.sunrise)); set('smSunset', hhmm(t.sunset));
    set('smNoon', hhmm(t.solarNoon)); set('smGolden', hhmm(t.goldenHourEnd) + ' / ' + hhmm(t.goldenHour));
    set('smFirst', hhmm(t.dawn)); set('smLast', hhmm(t.dusk));
    set('smDayLen', (t.sunrise && t.sunset) ? dur(t.sunset - t.sunrise) : (noonAlt > 0 ? dur(86400000) : dur(0)));

    // moon card
    set('smPhase', phaseEmoji(il.phase) + ' ' + phaseName(il.phase));
    set('smIllum', Math.round(il.fraction * 100) + '%');
    set('smMoonrise', mt.alwaysUp ? tr('always_up') : mt.alwaysDown ? tr('always_down') : hhmm(mt.rise));
    set('smMoonset', mt.alwaysUp ? tr('always_up') : mt.alwaysDown ? tr('always_down') : hhmm(mt.set));

    // special states (white nights / polar day / night)
    var banner = $('smBanner'), msg = '';
    if (nadirAlt > 0) msg = tr('polar_day');
    else if (noonAlt < 0) msg = tr('polar_night');
    else if (nadirAlt > -6) msg = tr('white_nights');         // civil twilight all night
    else if (nadirAlt > -18) msg = tr('no_astro_night');
    if (msg) { banner.textContent = msg; banner.style.display = 'block'; } else banner.style.display = 'none';

    drawLines();
  }
  function set(id, v) { var el = $(id); if (el) el.textContent = v; }

  function locate() {
    // A bare `return` here was a literally silent dead click: the button
    // did nothing and said nothing. __geo.notify explains why and reports it.
    if (!navigator.geolocation) { if (window.__geo) __geo.notify('no_api'); return; }
    var b = $('smLocate'); if (b) b.disabled = true;
    navigator.geolocation.getCurrentPosition(function (pos) { setLoc(pos.coords.latitude, pos.coords.longitude, true, true); if (map) map.setZoom(8); ae('feature_use', { slug: 'sun-moon-tracker', feature: 'locate' }); if (b) b.disabled = false; },
      function (err) { if (b) b.disabled = false; if (window.__geo) __geo.notify(err); }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 });
  }

  function boot() {
    try { window.Timbrica3D && window.Timbrica3D.init && window.Timbrica3D.init('sun-moon-tracker'); } catch (e) {}
    initMap();
    var lb = $('smLocate'); if (lb) lb.addEventListener('click', locate);
    var sc = $('smScrub'); if (sc) {
      sc.addEventListener('input', function () { scrubMin = parseInt(sc.value, 10); var d = previewDate(); $('smScrubT').textContent = hhmm(d); drawLines(); });
      var rb = $('smScrubReset'); if (rb) rb.addEventListener('click', function () { scrubMin = null; sc.value = Math.floor(((Date.now() + locOffsetMin() * 60000) % dayMs) / 60000); $('smScrubT').textContent = tr('now'); drawLines(); });
      sc.value = Math.floor(((Date.now() + locOffsetMin() * 60000) % dayMs) / 60000); $('smScrubT').textContent = tr('now');
    }
    setInterval(function () { if (scrubMin == null) render(); }, 60000);
    ae('tool_complete', { slug: 'sun-moon-tracker' });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
